/*
*****************************************************************************
*File : vue-validate.js
*Module : Dashboard Frontend
*Purpose : Vue-validation File
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
*/

import Vue from 'vue'
// import * as VeeValidate from 'vee-validate'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate)
